
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      import intlTelInput from "intl-tel-input";
import Cropper from "cropperjs";
export default {
  mounted() {
    var self = this;
    var app = self.$app;
    var $$ = self.$dom7;
    var calendarDefault = app.calendar.create({
      inputEl: '#profile-birthdate-calendar',
      dateFormat: "yyyy-mm-dd"
    });
    self.iti = intlTelInput(document.getElementById("profile-phone-number"), {
      allowDropdown: true,
      autoHideDialCode: true,
      autoPlaceholder: 'polite',
      //aggressive
      customContainer: '',
      customPlaceholder: function (selectedCountryPlaceholder, selectedCountryData) {
        return "e.g. " + selectedCountryPlaceholder;
      },
      dropdownContainer: null,
      excludeCountries: ['is'],
      formatOnDisplay: true,
      hiddenInput: "",
      initialCountry: "lb",
      // geoIpLookup: function (success, failure) {
      //     app.request.get("http://ip-api.com/json/", {}, function (resp) {
      //         var countryCode = (resp && resp.countryCode) ? resp.countryCode : "";
      //         success(countryCode);
      //     }, function (error) {
      //         console.log(error);
      //     }, "json");
      // },
      localizedCountries: {},
      nationalMode: true,
      //onlyCountries: ['lb'],
      placeholderNumberType: "MOBILE",
      preferredCountries: ["lb"],
      separateDialCode: true //utilsScript: "../../node_modules/intl-tel-input/build/js/utils"

    }); // var jcFound = false;
    // $$('[data-name="edit-profile"] #job-category-select option').each((index,option)=>{
    //         if ($$(option).val() === window.identity.job_category) {
    //             $$(option).attr('selected', true);
    //             $$('[data-name="edit-profile"] #job-category-select').val($$(option).val());
    //             $$('[data-name="edit-profile"] #job-category-select').trigger("change");
    //             jcFound = true;
    //         }
    // });
    // if(!jcFound){
    //     $$('[data-name="edit-profile"] #job-category-select').val(-99);
    //     $$('[data-name="edit-profile"] #job-category-select').trigger("change");
    //     if(window.identity.job_category) {
    //         $$('[data-name="edit-profile"] #job-category-select').parents(".item-content").addClass("display-none");
    //     }
    //     $$('[data-name="edit-profile"] #job-category-input').val(window.identity.job_category);
    // }
    //
    // var jtFound = false;
    // $$('[data-name="edit-profile"] #job-title-select option').each((index,option)=>{
    //         if ($$(option).val() === window.identity.job_title) {
    //             $$(option).attr('selected', true);
    //             $$('[data-name="edit-profile"] #job-title-select').val($$(option).val());
    //             $$('[data-name="edit-profile"] #job-title-select').trigger("change");
    //             jtFound = true;
    //         }
    // });
    // if(!jtFound){
    //     $$('[data-name="edit-profile"] #job-title-select').val(-99);
    //     $$('[data-name="edit-profile"] #job-title-select').trigger("change");
    //     if(window.identity.job_title) {
    //         $$('[data-name="edit-profile"] #job-title-select').parents(".item-content").addClass("display-none");
    //     }
    //     $$('[data-name="edit-profile"] #job-title-input').val(window.identity.job_title);
    // }

    var forceUppercaseInputs = ["#edit-profile-form input[name='firstname']", "#edit-profile-form input[name='lastname']"];
    forceUppercaseInputs.forEach(selector => {
      document.querySelectorAll(selector).forEach(input => {
        input.addEventListener('input', () => {
          const value = input.value;

          if (value.length > 0) {
            input.value = value.charAt(0).toUpperCase() + value.slice(1);
          }
        });
      });
    });
  },

  methods: {
    deleteAccount: function () {
      var self = this;
      var app = self.$app;
      app.dialog.confirm("Are you sure you want to delete your account? this action cannot be undone.", "<i class='material-icons text-color-red'>warning</i>", function () {
        self.$app.dialog.prompt('Enter your password to proceed', function (password) {
          self.$app.request({
            url: Url.to("user/delete-account"),
            method: "POST",
            data: {
              password: password
            },
            preloader: true,
            indicator: false,
            progress: false,
            success: function (data, status, xhr) {
              console.log(data);

              if (window.navigator && window.navigator.splashscreen) {
                window.navigator.splashscreen.show();
              }

              setTimeout(function () {
                User.logOut();
                window.location.reload();
              }, 250);
            }
          });
        });
      });
    },
    changePicture: function () {
      var self = this;
      var app = self.$app;

      if (window.IS_WEBAPP) {
        var input = document.createElement('input');
        input.type = 'file';
        input.accept = 'image/jpeg';

        input.onchange = e => {
          var files = e.target.files;

          var done = function (url) {
            input.value = ''; //image.src = url;

            console.log(url); //$modal.modal('show');

            app.views.current.router.navigate("/profile-picture/", {
              context: {
                src_url: url
              }
            });
          };

          var reader;
          var file;

          if (files && files.length > 0) {
            file = files[0];

            if (URL) {
              done(URL.createObjectURL(file));
            } else if (FileReader) {
              reader = new FileReader();

              reader.onload = function (e) {
                done(reader.result);
              };

              reader.readAsDataURL(file);
            }
          }
        };

        input.click();
        return;
      }

      if (!navigator.camera) {
        identity['image_thumb_url'] = 'data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAMAAACdt4HsAAAAeFBMVEUAAAAzMzMzMzMzMzMzMzNGRkY1NTUzMzMzMzM0NDQ1NTU1NTUzMzMzMzM0NDQzMzMzMzM0NDQzMzM0NDQ0NDQzMzM0NDQzMzMzMzM0NDQ1NTU8PDwzMzM0NDQ0NDQzMzM1NTUzMzMzMzM0NDQ0NDQ2NjY0NDQzMzOqhptJAAAAJ3RSTlMAkHj6sgUi9dZCNDDrua2mPDjmwJbhjIZkVB0P8MqhfkXggnFdE2JtmZz4AAABfElEQVRYw+3WyZKCMBCA4QYSE1RAVsV9nX7/N5xyBhVJdxJvHvhOWil+SQeqhNHo2+XnrNRqq8vsnMPH4qrAnqKK4RPTEg3lFHytMyRla/CymCNjvgAPqwhZ0Qqclmi1dP4+Oqwc+4+InZdpKnbFYxcL6/zN+aV5t5Y/erazMM5Pta9n43mawJrhUAtmAGdsIDHuH6hAwk4Qh6ZkALk5Bsb8n3v7CcMKnwImUOOA6BYqfFf7jnDfvdrYcYzxgEMBt3AgA3suEBC3Rkn8AvxBav+AJgNb/8CWDCh8iSZ3t/+F29+X/lkqMnDqB8zlFF9OZGBnBNgR7ciAMALsDgUZaKyBCfY0ZOBoBLhVPJIBqXqB8C7u3oX75/4MlQSS8H0OBNBa30ALDO0X0MC5+gWubEBqn4CWwJpF7kA0A4uLO3ABK+EKCLCTwh4QEpwFM0BezxcCPhBI8BHXdKCOwdOmUWZANRvwtwmL90AR0pfzZB4my+5/VxLmEkajr/YLWRirUhhi/VoAAAAASUVORK5CYII=';
        self.$app.request({
          url: Url.to("user/profile-picture-multi-db"),
          method: "POST",
          data: {
            image: identity['image_thumb_url']
          },
          success: function (data, status, xhr) {
            //console.log(data, status, xhr);
            self.user.image_thumb_url = window.identity['image_thumb_url'];
            self.$update();
            window.reloadIdentity();
            self.$app.dialog.alert('Profile picture updated successfully', function () {//self.$router.back();
            });
          }
        });
        return;
      }

      navigator.camera.getPicture(function (imageURI) {
        //console.log("data:image/jpeg;base64," + imageURI);
        identity['image_thumb_url'] = "data:image/jpeg;base64," + imageURI;
        self.$app.request({
          url: Url.to("user/profile-picture-multi-db"),
          method: "POST",
          data: {
            image: identity['image_thumb_url']
          },
          success: function (data, status, xhr) {
            //console.log(data, status, xhr);
            self.user.image_thumb_url = window.identity['image_thumb_url'];
            self.$update();
            window.reloadIdentity();
            self.$app.dialog.alert('Profile picture updated successfully', function () {//self.$router.back();
            });
          }
        });
        self.$setState({
          user: window.identity
        }, function () {});
      }, function (message) {//console.log(message);
      }, {
        allowEdit: true,
        quality: 50,
        destinationType: Camera.DestinationType.DATA_URL,
        encodingType: Camera.EncodingType.JPEG,
        mediaType: Camera.MediaType.PICTURE,
        correctOrientation: true,
        targetWidth: 250,
        targetHeight: 250,
        sourceType: Camera.PictureSourceType.SAVEDPHOTOALBUM
      });
    },
    edit: function () {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      self.is_edit = true;
      self.$update();
    },
    save: function () {
      var self = this;
      var app = self.$app;
      var editProfileData = self.$app.form.convertToData("#edit-profile-form");

      if (self.iti.isValidNumber()) {
        editProfileData['phone_number'] = self.iti.getNumber();
      } else {
        self.$app.dialog.alert('Please enter a valid phone number');
        return;
      } //console.log(self.$app.form.convertToData("#edit-profile-form"));


      app.dialog.confirm("Are you sure you want to update your profile information?", function () {
        self.$app.request({
          url: Url.to("user/edit-multi-db"),
          method: "POST",
          data: editProfileData,
          success: function (data, status, xhr) {
            //console.log(data, status, xhr);
            window.reloadIdentity();
            self.$app.dialog.alert('Profile updated successfully', function () {
              self.$router.back();
            });
          }
        });
      });
    }
  },
  data: function () {
    return {
      init: null,
      user: window.identity,
      is_edit: false
    };
  },
  id: 'c969497f27',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page no-toolbar navbar-extra-large" data-name="edit-profile">\n        <div class="navbar navbar-large navbar-extra-large">\n            <div class="navbar-bg"></div>\n            <div class="navbar-inner sliding">\n                <div class="left">\n                    <a href="#" class="link back icon-only">\n                        <i class="icon icon-back"></i>\n                        <!--                        <span class="if-not-md">Back</span>-->\n                    </a>\n                </div>\n                <div class="title">Edit profile</div>\n                <div class="right">\n                </div>\n                <div class="title-large">\n                    <div class="title-large-text">\n                        My profile\n                        <div class="subtitle-text">Edit profile</div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class="page-content">\n            <div class="text-align-center account-header">\n                <a href="#" @click="changePicture" class="account-picture" style="background-image: url(';
      r += c(ctx_1.user.image_thumb_url, ctx_1);
      r += ');">\n                    <div class="edit-profile-picture">\n                        <i class="icon material-icons-outlined">camera_alt</i>\n                    </div>\n                </a>\n            </div>\n            <div class="text-align-center account-header-title">';
      r += c(ctx_1.user.name, ctx_1);
      r += '</div>\n            <div class="text-align-center account-header-subtitle">';
      r += c(ctx_1.user.email, ctx_1);
      r += '</div>\n\n            ';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.is_edit, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <div class="block margin-top-half">\n                <button @click="edit" class="button button-outline">Edit</button>\n            </div>\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n            <div class="list no-margin-top no-hairline-top ';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.is_edit, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += 'disabled';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '" id="edit-profile-form">\n                <ul>\n                    <li class="item-content item-input">\n                        <div class="item-inner">\n                            <div class="item-title item-label">Your first name</div>\n                            <div class="item-input-wrap">\n                                <input type="text" name="firstname" placeholder="Required" value="';
      r += c(ctx_1.user.firstname, ctx_1);
      r += '" required validate>\n                            </div>\n                        </div>\n                    </li>\n\n                    <li class="item-content item-input">\n                        <div class="item-inner">\n                            <div class="item-title item-label">Your last name</div>\n                            <div class="item-input-wrap">\n                                <input type="text" name="lastname" placeholder="Required" value="';
      r += c(ctx_1.user.lastname, ctx_1);
      r += '" required validate>\n                            </div>\n                        </div>\n                    </li>\n\n                    <li class="item-content item-input">\n                        <div class="item-inner">\n                            <div class="item-title item-label">Your email</div>\n                            <div class="item-input-wrap">\n                                <input type="email" name="email" placeholder="Required" value="';
      r += c(ctx_1.user.email, ctx_1);
      r += '" required validate>\n                            </div>\n                        </div>\n                    </li>\n\n                    <li class="item-content item-input">\n                        <div class="item-inner">\n                            <div class="item-title item-label">Your phone number</div>\n                            <div class="item-input-wrap">\n                                <input type="text" name="phone_number" placeholder="Required" id="profile-phone-number"\n                                       value="';
      r += c(ctx_1.user.phone_number, ctx_1);
      r += '"\n                                       data-error-message="Please enter a valid phone number!">\n                            </div>\n                        </div>\n                    </li>\n                    <li class="item-content item-input display-none">\n                        <div class="item-inner">\n                            <div class="item-title item-label">Floor Number</div>\n                            <div class="item-input-wrap">\n                                <input type="text" name="floor_number" placeholder="Optional" value="';
      r += c(ctx_1.user.floor_number, ctx_1);
      r += '">\n                            </div>\n                        </div>\n                    </li>\n                    <li class="item-content item-input">\n                        <div class="item-inner">\n                            <div class="item-title item-label">Your date of birth</div>\n                            <div class="item-input-wrap">\n                                <input type="text" name="birthdate" placeholder="Optional" value="';
      r += c(ctx_1.user.birthdate, ctx_1);
      r += '" id="profile-birthdate-calendar">\n                            </div>\n                        </div>\n                    </li>\n\n\n                    <li class="item-content item-input" id="job-category-other">\n                        <div class="item-inner">\n                            <div class="item-title item-label">Specify Job Category</div>\n                            <div class="item-input-wrap">\n                                <input type="text" name="job_category" value="';
      r += c(ctx_1.user.job_category, ctx_1);
      r += '"  placeholder="Specify Job Category" id="job-category-input"/>\n<!--                                <span class="input-clear-button"></span>-->\n                            </div>\n                        </div>\n                    </li>\n\n                    <li class="item-content item-input" id="job-title-other">\n                        <div class="item-inner">\n                            <div class="item-title item-label">Specify Job Title / occupation</div>\n                            <div class="item-input-wrap">\n                                <input type="text" name="job_title"  value="';
      r += c(ctx_1.user.job_title, ctx_1);
      r += '"placeholder="Specify Job Title / occupation" id="job-title-input"/>\n<!--                                <span class="input-clear-button"></span>-->\n                            </div>\n                        </div>\n                    </li>\n\n                </ul>\n            </div>\n            ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.is_edit, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <div class="block no-margin-top">\n                <button @click="save" class="button button-large button-fill">Save</button>\n            </div>\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n            <div class="list links-list no-margin-bottom">\n                <ul>\n                    <li class="large-gray-link"><a href="/change-password/">Change password</a></li>\n                </ul>\n                <div class="padding-horizontal-half text-color-gray">\n                    <small>\n                    Change your password before ';
      r += c(ctx_1.user.password_valid_until, ctx_1);
      r += '\n                    </small>\n                </div>\n            </div>\n\n            <div class="list links-list no-margin-bottom hide-webapp">\n                <ul>\n                    <li class="large-gray-link"><a href="#" @click="deleteAccount">Delete Account</a></li>\n                </ul>\n            </div>\n        </div>\n    </div>\n    <style>\n        .item-input .smart-select .item-after {\n            height: 44px;\n            width: 100%;\n            margin: 0;\n            max-width: 100%;\n            box-sizing: border-box;\n            align-items: center;\n            display: flex;\n            justify-content: flex-start;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n        }\n    </style>\n';
      return r;
    }(this);
  },

  style: `
        .item-input .smart-select .item-after {
            height: 44px;
            width: 100%;
            margin: 0;
            max-width: 100%;
            box-sizing: border-box;
            align-items: center;
            display: flex;
            justify-content: flex-start;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    `,
  styleScoped: false
};
    